<template>
<ValidationObserver ref="observer">
  <form ref="edit_faktur_form" @submit.prevent="handleSubmit(updateFaktur)">

    <md-card>

      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Edit Faktur
        </h4>
      </md-card-header> -->
      <md-card-content>
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            Faktur No. (Read)<span style="color:red">*</span>
          </label> -->
          <div class="md-layout-item md-size-50 md-small-size-50">
            <validation-provider rules="fakturno" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">(Read) Faktur No</label>
              <md-input v-model="faktur_no" disabled required/>
              <validation-error :errors="apiValidationErrors.faktur_no" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        <!-- </div>

        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Faktur Datetime (Read)<span style="color:red"> *</span>
          </label> -->
          <div class="md-layout-item md-size-50 md-small-size-50">
            <validation-provider rules="datetime" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">(Read) Faktur Date</label>
              <md-input v-model="faktur_invoice_datetime" disabled required/>
              <validation-error :errors="apiValidationErrors.faktur_invoice_datetime" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            PKB No. (Read)<span style="color:red">*</span>
          </label> -->
          <div class="md-layout-item md-size-100 md-small-size-100">
            <validation-provider rules="pkbno" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">(Read) PKB No</label>
              <md-input type="hidden" readonly v-model="faktur_pkb_id" required/>
              <md-input v-model="faktur_pkb_no" disabled/>
              <validation-error :errors="apiValidationErrors.faktur_pkb_no" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">SA Contact</span>
          </label> -->
          <div class="md-layout-item md-size-100 md-small-size-100">
            <validation-provider rules="sacontact" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">SA Contact</label>
              <md-input v-model="faktur_sa_contact" readonly required/>
              <validation-error :errors="apiValidationErrors.faktur_sa_contact" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Date In</span>
          </label> -->
          <div class="md-layout-item md-size-50 md-small-size-50">
            <validation-provider rules="datein" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">Date In</label>
              <md-input v-model="faktur_date_in" readonly required/>
              <validation-error :errors="apiValidationErrors.faktur_date_in" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        <!-- </div>

        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Date Out</span>
          </label> -->
          <div class="md-layout-item">
            <validation-provider rules="dateout" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">Date Out</label>
              <md-input v-model="faktur_date_out" readonly required/>
              <validation-error :errors="apiValidationErrors.faktur_date_out" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">KM In</span>
          </label> -->
          <div class="md-layout-item md-size-50 md-small-size-50">
            <validation-provider rules="kmin" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">KM In</label>
              <md-input v-model="faktur_customer_km_in" type="text" v-on:keypress="NumbersOnly" readonly required/>
              <validation-error :errors="apiValidationErrors.faktur_customer_km_in" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        <!-- </div>

        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">KM Out</span>
          </label> -->
          <div class="md-layout-item md-size-50 md-small-size-50">
            <validation-provider rules="kmout" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">KM Out</label>
              <md-input v-model="faktur_customer_km_out" type="text" v-on:keypress="NumbersOnly" required/>
              <validation-error :errors="apiValidationErrors.faktur_customer_km_out" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Total Biaya Jasa</span>
          </label> -->
          <div class="md-layout-item md-size-50 md-small-size-50">
            <md-field class="md-invalid">
              <label for="">Total Biaya Jasa</label>
              <md-input v-model="faktur_total_biaya_jasa" type="text" v-on:keypress="NumbersOnly"  readonly/>
              <validation-error :errors="apiValidationErrors.faktur_total_biaya_jasa" />
            </md-field>
          </div>
        <!-- </div>

        <div class="md-layout"> -->
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Total Biaya Spare Part</span>
          </label> -->
          <div class="md-layout-item md-size-50 md-small-size-50">
            <md-field class="md-invalid">
              <label for="">Total Biaya Spare Part</label>
              <md-input v-model="faktur_total_biaya_spare_part" type="text" v-on:keypress="NumbersOnly" readonly/>
              <validation-error :errors="apiValidationErrors.faktur_total_biaya_spare_part" />
            </md-field>
          </div>
        </div>
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Subtotal</span>
          </label> -->
          <div class="md-layout-item md-size-100 md-small-size-100">
            <md-field class="md-invalid">
              <label for="">Subtotal</label>
              <md-input v-model="faktur_sub_total" type="text" v-on:keypress="NumbersOnly" readonly/>
            </md-field>
          </div>
        </div>
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">PPN</span>
          </label> -->
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <label for="">PPN</label>
              <md-input v-model="faktur_ppn" type="text" v-on:keypress="NumbersOnly" readonly/>
            </md-field>
          </div>
        </div>
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Materai</span>
          </label> -->
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <label for="">Materai</label>
              <md-input v-model="faktur_materai" type="text" v-on:keypress="NumbersOnly" @change="changeMaterai(faktur_materai)" />
            </md-field>
          </div>
        </div>
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">TOTAL</span>
          </label> -->
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <label for="">Total</label>
              <md-input v-model="faktur_total" type="text" v-on:keypress="NumbersOnly" readonly/>
            </md-field>
          </div>
        </div>

        <!-- <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Bahan</span>
          </label>
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <md-input v-model="faktur_bahan" />
              <validation-error :errors="apiValidationErrors.faktur_bahan" />
            </md-field>
          </div>
        </div> -->

        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Saran</span>
          </label> -->
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <label for="">Saran</label>
              <md-textarea v-model="faktur_saran" md-counter="100" maxlength="100" md-autogrow></md-textarea>
              <md-avatar >
                <md-icon style="color:blue;">report</md-icon>
                <md-tooltip md-direction="left">You can enter to add new row</md-tooltip>
              </md-avatar>
              <validation-error :errors="apiValidationErrors.faktur_saran" />
            </md-field>
          </div>
        </div>
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Ketentuan</span>
          </label> -->
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <label for="">Ketentuan</label>
              <md-textarea v-model="faktur_ketentuan" md-counter="100" maxlength="100" md-autogrow></md-textarea>
              <md-avatar >
                <md-icon style="color:blue;">report</md-icon>
                <md-tooltip md-direction="left">You can enter to add new row</md-tooltip>
              </md-avatar>
              <validation-error :errors="apiValidationErrors.faktur_ketentuan" />
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Kasir</span>
          </label> -->
          <div class="md-layout-item">
            <validation-provider rules="kmout" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">Kasir</label>
              <md-select v-model="faktur_kasir">
                <md-option v-for="option in options_kasir_list" :key="option.value" :value="option.id">
                  {{ option.name }}
                </md-option>
              </md-select>
              <validation-error :errors="apiValidationErrors.faktur_kasir" />
            </md-field>
            <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
      </md-card-content>
    
    <md-card-actions>
        <md-button class="md-info md-dense" @click="editConfirmation">
          Update
        </md-button>
        <md-button class="md-dense" @click="backtoList">
          Go to List
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</ValidationObserver>
</template>

<script>
  import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import { extend, validate, localize, ValidationObserver  } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
  import { min, max, numeric } from "vee-validate/dist/rules";
  import en from "vee-validate/dist/locale/en.json";
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2';
  import Swal from 'sweetalert2';

  Vue.use(VueSweetalert2);
  localize({
      en
  });

//config validation input form start
  extend("min", min);
  extend("max", max);
  extend("numeric", numeric);


  extend('digits_between', {
    async validate(value, { min, max }) {
          const res = await validate(value, `numeric|min:${min}|max:${max}`,)
              return res.valid;
    },
    params: ['min', 'max'],
    message: 'SA Contact must be between {min} and {max} digits'
  });
  
  extend('fakturno', {
  ...required,
  message: 'Faktur No. field is required'
});
extend('datetime', {
  ...required,
  message: 'Faktur Datetime field is required'
});
extend('datein', {
  ...required,
  message: 'Date In field is required'
  });
  extend('dateout', {
    ...required,
    message: 'Date Out field is required'
  });
  extend('sacontact', {
    ...required,
    message: 'SA Contact field is required'
  });
  extend('kasir', {
    ...required,
    message: 'Kasir field is required'
  });
  extend('kmin', {
    ...required,
    message: 'KM Out field is required'
  });
  extend('kmout', {
    ...required,
    message: 'KM Out field is required'
  });
  //config validation input form end
  
  export default {
    name: "edit-faktur",

    

    components: {ValidationError, ValidationObserver },

    mixins: [formMixin],

   data: () => ({
      faktur_no: null,
      faktur_invoice_datetime: null,
      faktur_pkb_id: null,
      faktur_sa_contact: null,
      faktur_date_out: null,
      faktur_saran: null,
      faktur_ketentuan: null,
      faktur_kasir: null,
      faktur_total_biaya_spare_part: null,
      faktur_total_biaya_jasa: null,
      faktur_customer_km_in: null,
      faktur_date_in: null,
      faktur_customer_km_out: null,
      faktur_pkb_no: null,
      faktur_sub_total: 0,
      faktur_ppn: 0,
      faktur_materai: 0,
      faktur_total: 0,
      options_kasir_list: null,
      
    }),

    created() {
      this.getFakturData();
    },


    methods: {

      NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

    
      //kembali ke list
      backtoList(id) {
      this.$router.replace({ name: 'List Faktur', params: { id: id } })
    },
      //fungsik perubahan input materai
      changeMaterai(data){
        //hitung total
        this.faktur_total = this.faktur_sub_total + this.faktur_ppn + parseInt(data)
      },

      //fungsi untung mendapatkan data yang aka diedit + data lain yang dibuth kan
      async getFakturData(){

        
        
        //check apakah id ikut terkirim ketika memanggil page edit
        if(this.$route.params.id){
          
        //jika ada ambil data faktur berdasarkan id
        await this.$store.dispatch("workshop_faktur/get", this.$route.params.id)
        this.faktur = await this.$store.getters["workshop_faktur/faktur"]
        this.faktur_no = this.faktur.faktur_no;
        this.faktur_invoice_datetime = this.faktur.faktur_invoice_datetime;
        this.faktur_pkb_id = this.faktur.faktur_pkb_id;
        this.faktur_pkb_no =  this.faktur.faktur_pkb.pkb_no;
        this.faktur_sa_contact = this.faktur.faktur_sa_contact;
        this.faktur_date_in = this.faktur.faktur_date_in;
        this.faktur_date_out = this.faktur.faktur_date_out;
        this.faktur_saran = this.faktur.faktur_saran;
        this.faktur_ketentuan = this.faktur.faktur_ketentuan;
        this.faktur_kasir = this.faktur.faktur_kasir_name.id
        this.faktur_total_biaya_jasa = this.faktur.faktur_total_biaya_jasa;
        this.faktur_total_biaya_spare_part = this.faktur.faktur_total_biaya_spare_part;
        this.faktur_sub_total = parseInt(this.faktur.faktur_total_biaya_jasa) + parseInt(this.faktur.faktur_total_biaya_spare_part)
        this.faktur_customer_km_out = this.faktur.faktur_customer_km_out;
        this.faktur_customer_km_in = this.faktur.faktur_customer_km_in;
        this.faktur_ppn = this.faktur.faktur_ppn;
        this.faktur_materai = this.faktur.faktur_materai;
        this.faktur_total = parseInt(this.faktur.faktur_total_biaya_jasa) + parseInt(this.faktur.faktur_total_biaya_spare_part) + parseInt(this.faktur.faktur_ppn) + parseInt(this.faktur.faktur_materai);
        

          //ambil data list kasir
          var query = {"filter":{role:'kasir',pool:faktur.faktur_pkb.service_estimate.service_estimate_pool_id}}
            await this.$store.dispatch("users/list",query) 
            this.options_kasir_list = await this.$store.getters["users/list"]

        }
      },
      
      //fungsi edit
      async editConfirmation(id) {
        
        //check validation input
      if (!await this.$refs.observer.validate()) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be edited!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Edit it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.updateFaktur(id)
          }
        });
    },

      //fungsi kirim data ke server
      async updateFaktur() {

        // if(this.$route.params.id == null || !this.$route.params.id) {
        //   await this.$store.dispatch("alerts/error", "You are not allowed not change data of default users.")
        //   return
        // }

        
        const data = {
          id: this.faktur.id,
          type: "workshop_fakturs",
          faktur_no: this.faktur_no,
          faktur_invoice_datetime: this.faktur_invoice_datetime,
          faktur_pkb_id: this.faktur_pkb_id,
          faktur_sa_contact: this.faktur_sa_contact,
          faktur_date_in: this.faktur_date_in,
          faktur_date_out: this.faktur_date_out,
          faktur_customer_km_in: this.faktur_customer_km_in,
          faktur_customer_km_out: this.faktur_customer_km_out,
          faktur_total_biaya_jasa: this.faktur_total_biaya_jasa,
          faktur_total_biaya_spare_part: this.faktur_total_biaya_spare_part,
          faktur_ppn: this.faktur_ppn,
          faktur_materai: this.faktur_materai,
          faktur_ketentuan: this.faktur_ketentuan,
          faktur_saran: this.faktur_saran,
          faktur_kasir: this.faktur_kasir
        }


        try {
          //kirim data update ke api
          await this.$store.dispatch("workshop_faktur/update", data)
          //panggil alert succes
          await this.$store.dispatch("alerts/success", "Faktur data changed successfully.")
          //kembali ke list
          await this.$router.replace({name: 'List Faktur'});
          //this.$refs['password_form'].reset()
        } catch (e) {
          //panggil alert error
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          this.setApiValidation(e.response.data.errors)
        }

      }
    }
  };
</script>
